import "./styles.css";

const root = document.querySelector<HTMLDivElement>("#about-root");
if (!root) throw new Error("About root is missing");

const lastUpdated = "2026年8月20日";

root.innerHTML = `
  <header class="about-page-header">
    <a class="about-back" href="/">ストアへ戻る</a>
  </header>
  <main class="about-page-main about-article">
    <p class="last-updated">最終更新日：${lastUpdated}</p>

    <h1>「クイヤ」とは？9が嫌いな謎の害獣ミームの元ネタ・生態・撃退法まで完全解説｜3Dショップ「クイ屋」</h1>

    <p>最近、SNSや動画サイトで話題になっている謎の動物<strong>「クイヤ」</strong>。<br>「数字の9を嫌う害獣」「モルモットやビーバーに似た姿」「夏になると畑を荒らす」――そんな言葉を目にして、「本当にいるの？」と気になっている方も多いのではないでしょうか。</p>

    <figure class="illust">
      <img src="/img/kuiya-illustration_01.png" alt="ネットミームの架空動物クイヤのイラスト。数字の9の看板を警戒する、モルモットやビーバーに似た姿" loading="lazy">
    </figure>

    <p>先に結論からお伝えすると、<strong>クイヤは実在しません。</strong><br>テレビ番組のひとりのボケから生まれ、ネットの人々が愛情を込めて生態を作り上げていった“架空の動物”です。このページでは、クイヤの元ネタ・2026年の再燃の経緯・ネットで定着した生態を徹底解説し、最後に、その愛すべきミームと名前を同じくする当店<strong>「クイ屋（QUIYA）」</strong>についてご紹介します。</p>

    <ul class="toc">
      <li><a href="#kuiya-summary">クイヤとは？10秒でわかる要約</a></li>
      <li><a href="#kuiya-origin">クイヤの元ネタは『ガキの使い』</a></li>
      <li><a href="#kuiya-2026">2026年に再燃した理由</a></li>
      <li><a href="#kuiya-ecology">クイヤの生態と撃退法</a></li>
      <li><a href="#quiya-shop">当店「クイ屋」について</a></li>
      <li><a href="#kuiya-faq">よくある質問（FAQ）</a></li>
    </ul>

    <h2 id="kuiya-summary">クイヤとは？10秒でわかる要約</h2>
    <ul>
      <li><strong>正体：</strong>テレビ番組のボケから生まれた架空の動物（ネットミーム）</li>
      <li><strong>元ネタ：</strong>2011年4月17日放送『ダウンタウンのガキの使いやあらへんで!!』</li>
      <li><strong>最大の特徴：</strong>数字の「9」を極端に嫌う</li>
      <li><strong>見た目（ネット設定）：</strong>モルモットやビーバーに似た小動物</li>
      <li><strong>習性（ネット設定）：</strong>夏場に穴を掘って畑を荒らす害獣</li>
      <li><strong>撃退法：</strong>数字の「9」を突きつけるだけ</li>
    </ul>

    <h2 id="kuiya-origin">クイヤの元ネタは『ガキの使い』――松本人志の伝説のボケ</h2>
    <p>クイヤの起源は、日本テレビ系のバラエティ番組『ダウンタウンのガキの使いやあらへんで!!』。2011年4月17日の放送で、「数字の9が嫌いな動物ってなぁに？」というなぞなぞが出題されました。</p>
    <p>本来の正解は<strong>スカンク</strong>。「9（く）を好かん」というダジャレです。<br>しかしこの問題に対し、松本人志さんが堂々と答えたのが<strong>「クイヤ」</strong>でした。</p>
    <p>「クイヤって何ですか？」と突っ込まれた松本さんは、まるで当然の動物であるかのように「9が嫌いやから！『クイヤ』っていう動物!! シッポもある!!」と平然と言い放ち、スタジオを笑いに包みました。</p>
    <p>つまりクイヤはもともと、図鑑にも載っていない、<strong>「あまりにもらしい嘘」</strong>として生まれた架空の動物だったのです。</p>

    <figure class="illust">
      <img src="/img/kuiya-origin_01.png" alt="『ダウンタウンのガキの使いやあらへんで!!』で松本人志が「クイヤ」と答えた伝説のボケの様子" loading="lazy">
      <figcaption>参考：『ダウンタウンのガキの使いやあらへんで!!』（日本テレビ）</figcaption>
    </figure>

    <h2 id="kuiya-2026">なぜ今？2026年「実在疑惑」の再燃</h2>
    <p>15年も前のボケだったクイヤを再び世間に押し上げたのが、2026年8月、ショートスリーパーとして知られる<strong>堀大輔</strong>さんの生配信での出来事でした。</p>
    <p>視聴者からの「害獣のクイヤが大量発生して夏を感じる」というイタズラ気味のスーパーチャットに対し、堀さんが「あークイヤか！穴掘ったりするやつでしたっけ？」と、まるで実在する動物であるかのように自然に合わせて返してしまったのです。</p>
    <p>このやり取りの切り抜きがSNSやショート動画で拡散し、「クイヤって本当にいるの？」「昔からいる害獣なの？」と憶測が爆発。<br>2011年のテレビのボケが、2026年の配信カルチャーを経て、再びネットの記憶に刻まれました。</p>

    <figure class="illust" style="max-width: 66%; margin-left: auto; margin-right: auto;">
      <img src="/img/kuiya-origin_02.png" alt="ショートスリーパー堀大輔さんの生配信で、クイヤについて自然に返答した様子" loading="lazy">
      <figcaption>参考：堀大輔さんの生配信（2026年8月）</figcaption>
    </figure>

    <h2 id="kuiya-ecology">クイヤの生態｜ネットで構築された“設定”</h2>
    <p>再燃をきっかけに、ファンの大喜利と愛情が積み重なり、「クイヤの生態」は驚くほど具体的に出来上がっていきました。ネットで定着している設定をまとめます。</p>
    <ul>
      <li><strong>見た目：</strong>モルモットやビーバーに似た小動物。松本さん曰く「シッポもある」。</li>
      <li><strong>生息地：</strong>地面に穴を掘って暮らし、畑や田んぼの周辺で目撃される。</li>
      <li><strong>習性：</strong>夏場に活発化し、農作物を荒らす厄介な害獣。その出現は「夏の訪れ」を感じさせる。</li>
      <li><strong>弱点：</strong>数字の「9」を極端に嫌う。</li>
    </ul>

    <h3>クイヤの撃退法：「9」を突きつけるだけ</h3>
    <p>クイヤの撃退法は非常にシンプルで、<strong>数字の「9」を突きつけるだけ</strong>。<br>9が嫌いなため、近づけずに逃げ去っていくとされています。</p>
    <p>ただし噛まれると感染症のリスクもあり、放置すれば農作物が荒らされるため、畑で遭遇した際は油断せず、しっかりと「9」を掲げてクイヤ対策を行いましょう。大きな声で｢9｣と叫ぶだけでも効果があります。</p>

    <h2>クイヤは実在しない。だからこそ、愛される。</h2>
    <p>テレビのボケ、配信のハプニング、そしてネットの人々の創造力。<br>クイヤはそれらすべてが積み重なって生まれた<strong>「ミームの生き物」</strong>です。</p>
    <p>実在しない動物が、これだけ「いそうで、愛おしい」と感じられることこそ、ネットカルチャーの面白さ。当店「クイ屋」も、このいたずら心あふれるミームへの愛情から生まれました。</p>

    <h2 id="quiya-shop">当店「クイ屋（QUIYA）」について</h2>
    <p><strong>「クイ屋（QUIYA）」</strong>は、あのミーム動物“クイヤ”の名を冠した、<a href="/">歩いて棚を選ぶ3Dレンタルビデオショップ</a>です。<br>店名の由来は、英語の<strong>「quiet（静かに）」</strong>とレンタルビデオ<strong>「屋」</strong>。愛すべきミーム「クイヤ」との語感の一致は、私たちなりのオマージュでもあります。</p>

    <figure class="illust">
      <img src="/img/kuiya-illustration_02.png" alt="ネットミームの架空動物クイヤがVHSを持っているイラスト" loading="lazy">
    </figure>

    <h3>なぜ今、レンタルビデオ店をつくるのか</h3>
    <p>今ではすっかり廃れてしまった、レンタルビデオショップ、そしてその奥のアダルトコーナー。<br>冷静に考えれば、たしかに不便な場所でした。</p>
    <p>ビデオという使いづらい媒体、わざわざ足を運ばなければいけない手間、そして店員や他の客の視線に耐えながら手に取らなければいけない恥ずかしさ。<br>ネットでポチったほうが、楽で便利すぎる。勝負になるはずがありません。</p>
    <p>それでも、あの空間にしか存在しなかったものが、確かにありました。</p>

    <h3>届けたい体験</h3>
    <p>効率だけでは、あの1本には出会えません。<br>クイ屋では、看板を見て、通路を歩き、手に取るように探す――あの頃の探し方を、そのまま3D空間で再現しています。</p>
    <p>意味もなくウロウロして、迷子になって、棚の隅の変なジャケットに笑う。そんな「無駄で、豊かな時間」を、もう一度。</p>
    <p>皆さんにも、昔のそういった気持ちを取り戻してほしい。思い出して、体験してほしい。ここは、<strong>あなた一人だけの特別な空間</strong>です。</p>

    <figure class="store-figure">
      <img src="/img/quiya-store_01.png" alt="古き良きレンタルビデオ店の店内を再現した3D空間。手書きポップの棚と、奥にカーテンのかかったアダルトコーナー" loading="lazy">
    </figure>

    <figure class="store-figure">
      <img src="/img/quiya-store_02.png" alt="古き良きレンタルビデオ店の店内を再現した3D空間。手書きポップの棚と、奥にカーテンのかかったアダルトコーナー" loading="lazy">
    </figure>

    <p class="article-cta-wrap"><a class="article-cta" href="/">クイ屋を体験する（3Dストアへ）</a></p>

    <h2 id="kuiya-faq">クイヤ＆クイ屋 よくある質問（FAQ）</h2>
    <h3>Q. クイヤは実在する動物ですか？</h3>
    <p>A. 実在しません。2011年のテレビ番組『ガキの使い』のボケから生まれ、ネットミームとして生態が作り上げられた架空の動物です。</p>
    <h3>Q. なぜクイヤは「9」を嫌うのですか？</h3>
    <p>A. 「9（く）が嫌やからクイヤ」というダジャレが名前の由来だからです。撃退法も「9」を突きつけるだけ、とされています。</p>
    <h3>Q. クイヤと店「クイ屋」の関係は？</h3>
    <p>A. 店名は「quiet（静かに）＋屋」が由来です。愛すべきミーム動物“クイヤ”との語感の一致は、当店なりのオマージュです。</p>
    <h3>Q. 「クイ屋」は無料で使えますか？</h3>
    <p>A. はい。登録もインストールも不要で、店内を自由に歩き回れます。</p>
    <h3>Q. 「クイ屋」はアダルトサイトですか？</h3>
    <p>A. レンタルビデオ店と、そのアダルトコーナーの空気感を再現した作品です。18歳未満の方のご利用はご遠慮ください。</p>

    <p class="last-updated">最終更新日：${lastUpdated}</p>

    <p class="article-cta-wrap article-cta-wrap--end"><a class="article-cta" href="/">▶ クイ屋（3Dレンタルビデオショップ）を今すぐ体験する</a></p>
  </main>
`;
